export default __webpack_public_path__ + "static/media/staticmap.30476ea2.png";